import { type TPlayerScore } from '../types'

export const scoreSequence: TPlayerScore[] = [0, 15, 30, 40]
export const AD = 200
export const GAME = 100
